import { BaseTransformationVisitor } from './baseTransformation.visitor';

export class UnionVisitor extends BaseTransformationVisitor {
}
